import axios from 'axios'
import { API_ENDPOINT_BASE, ROOT, PASSENGER_TYPES } from '@/constans'
import { set } from '@/utils'
import { stringify } from 'qs'
import {
  ID,
  ROOMING,
  STATUS,
  RATE,
  SEATS,
  INFOAS,
  INFOASCB,
  KIDS,
  BUDGET,
  PASSENGERS,
  PRICE,
  DEPARTURE,
  AGENCY,
  LOADING,
  CODE,
  NOTES,
  COUNTDOWN,
  TIMER
} from '@/store/mutations'
import swal from 'sweetalert2'

var Timer

export default {
  namespaced: true,
  state: {
    id: null,
    status: null,
    rate: {},
    seats: [],
    passengers: [],
    rooming: [],
    budget: {},
    price: {},
    departure: {},
    notes: '',
    code: '',
    session: 901
  },
  mutations: {
    [ID]: set('id'),
    [STATUS]: set('status'),
    [RATE]: set('rate'),
    [SEATS]: set('seats'),
    [BUDGET]: set('budget'),
    [PRICE]: set('price'),
    [PASSENGERS]: set('passengers'),
    [DEPARTURE]: set('departure'),
    [ROOMING]: set('rooming'),
    [CODE]: set('code'),
    [NOTES]: set('notes'),
    [COUNTDOWN]: set('countdown'),
    countdown (state) {
      if (state.session > 0) {
        state.session = state.session - 1
      } else {
        window.location.reload()
      }
    }
  },
  actions: {
    TIMER: ({ commit }) => {
      Timer = setInterval(() => commit('countdown'), 1000)
    },
    EDIT_PASSENGER ({ commit, state }, data) {
      commit(
        PASSENGERS,
        state.passengers.map(passenger =>
          passenger.id == data.id ? Object.assign({}, passenger, data) : passenger
        )
      )
    },
    SIT ({ commit, state }, { seat, id }) {
      const seating = {
        seat_id: seat.id,
        seat_categ: seat.categ,
        seat_categ_str: seat.categ_str
      }

      commit(
        PASSENGERS,
        state.passengers.map(passenger =>
          passenger.id == id ? Object.assign({}, passenger, seating) : passenger
        )
      )
    },
    DISTRIBUTE ({ commit, state }, { uid, id }) {
      commit(
        PASSENGERS,
        state.passengers.map(passenger =>
          passenger.id == id
            ? Object.assign({}, passenger, { rooms: passenger.rooms.concat([uid]) })
            : passenger
        )
      )
    },
    OPEN ({ commit }, reservation_id) {
      commit(LOADING, true, ROOT)
      return new Promise((resolve, reject) => {
        axios
          .post(API_ENDPOINT_BASE + '/booking/open/' + reservation_id)
          .then(({ data }) => {
            commit(AGENCY, data.agency)
            commit(ID, reservation_id)
            commit(STATUS, 'rooming')
            commit(AGENCY, data.agency)
            commit(ID, data.id)
            commit(INFOAS, data.infoas)
            commit(INFOASCB, data.infoascb)
            commit(DEPARTURE, data.departure)
            commit(KIDS, data.kids)
            commit(PASSENGERS, data.passengers)
            commit(PRICE, data.price)
            commit(RATE, data.rate)
            commit(SEATS, data.seats)
            commit(STATUS, data.status)
            resolve()
          })
          .catch(error => {
            commit(ID, null)
            commit(STATUS, null)
            commit(RATE, {})
            commit(SEATS, [])
            commit(INFOAS, {})
            commit(INFOASCB, {})
            commit(KIDS, {})
            commit(PASSENGERS, [])
            commit(PRICE, {})
            commit(DEPARTURE, {})
            commit(AGENCY, {})
            swal({ html: error.response.data.msg, type: 'error' })
            reject()
          })
          .finally(() => commit(LOADING, false, ROOT))
      })
    },
    CONFIRM ({ commit, state }) {
      commit(LOADING, true, ROOT)
      const { id, rate, rooming, departure, seats, notes } = state

      if (Timer) {
        clearInterval(Timer)
        commit(COUNTDOWN, 901)
      }

      return new Promise((resolve, reject) => {
        return axios
          .post(
            API_ENDPOINT_BASE + '/booking/confirm/' + id,
            stringify({
              rooming,
              seats,
              notes,
              rate_id: rate.id,
              departure_id: departure.id
            })
          )
          .then(({ data }) => {
            commit(PRICE, data.price)
            commit(PASSENGERS, data.passengers)
            commit(STATUS, 'success')
            resolve(data)
          })
          .catch(error => {
            reject(error.response.data.msg)
          })
          .finally(() => commit(LOADING, false, ROOT))
      })
    },
    BUDGETING ({ commit, state }) {
      commit(LOADING, true, ROOT)

      const { id, passengers, rate, code, departure } = state

      return new Promise((resolve, reject) => {
        const every_pax_has_seat = passengers.every(p => {
          let rtrn
          switch (p.type) {
            case PASSENGER_TYPES.infoas.str:
              rtrn = true
              break
            case PASSENGER_TYPES.infoascb.str:
              rtrn = !!p.seat_id
              break
            default:
              rtrn = p.rooming && p.seat_id
              break
          }
          return rtrn
        })

        if (every_pax_has_seat) {
          axios
            .post(
              API_ENDPOINT_BASE + '/booking/budgeting/',
              stringify({
                passengers,
                code,
                rate_id: rate.id,
                departure_id: departure.id,
                id
              })
            )
            .then(({ data }) => {
              commit(ID, data.id)
              commit(BUDGET, data)
              resolve(data)
            })
            .catch(error => {
              swal({ html: error.response.data.msg, type: 'error' })
              reject(error)
            })
            .finally(() => commit(LOADING, false, ROOT))
        } else {
          commit(LOADING, false, ROOT)
          resolve()
        }
      })
    },
    ROOMING ({ commit }, notes) {
      commit(NOTES, notes)
      commit(STATUS, 'conditions')
    },
    RATES ({ commit, state }, rate) {
      commit(LOADING, true, ROOT)
      return new Promise((resolve, reject) => {
        axios
          .post(
            API_ENDPOINT_BASE + '/booking/rates',
            stringify({ rate, reservation: state.id })
          )
          .then(({ data }) => {
            commit(AGENCY, data.agency)
            commit(ID, data.id)
            commit(INFOAS, data.infoas)
            commit(INFOASCB, data.infoascb)
            commit(DEPARTURE, data.departure)
            commit(KIDS, data.kids)
            commit(PASSENGERS, data.passengers)
            commit(PRICE, data.price)
            commit(RATE, data.rate)
            commit(SEATS, data.seats)
            commit(STATUS, data.status)
            resolve()
          })
          .catch(error => {
            commit(ID, null)
            commit(STATUS, null)
            commit(RATE, {})
            commit(SEATS, [])
            commit(INFOAS, {})
            commit(INFOASCB, {})
            commit(KIDS, {})
            commit(PASSENGERS, [])
            commit(PRICE, {})
            commit(DEPARTURE, {})
            commit(AGENCY, {})
            swal({ html: error.response.data.msg, type: 'error' })
            reject()
          })
          .finally(() => commit(LOADING, false, ROOT))
      })
    },
    INIT ({ commit }, { departure, seats, passengers }) {
      commit(LOADING, true, ROOT)

      return new Promise((resolve, reject) => {
        axios
          .post(
            API_ENDPOINT_BASE + '/booking/init',
            stringify({ departure: departure.id, seats: seats.map(seat => seat.id) })
          )
          .then(({ data }) => {
            commit(ID, data.id)
            commit(STATUS, 'rates')
            commit(PASSENGERS, passengers)
            commit(DEPARTURE, departure)
            commit(SEATS, seats)
            resolve(data)
          })
          .catch(error => {
            swal({ html: error.response.data.msg, type: 'error' })
            reject(error)
          })
          .finally(() => commit(LOADING, false, ROOT))
      })
    },
    RESET ({ commit }) {
      commit(ID, null)
      commit(STATUS, null)
      commit(RATE, {})
      commit(SEATS, [])
      commit(BUDGET, {})
      commit(PASSENGERS, [])
      commit(PRICE, {})
      commit(DEPARTURE, {})
      commit(ROOMING, [])
      commit(NOTES, '')
      commit(CODE, '')
    },
    ASSIGN ({ commit, state, dispatch }) {
      swal.fire({
        input: 'text',
        title: 'Bloquear lugares para la agencia.',
        text: 'Usar un nombre o texto como referencia para la reserva.',
        showCancelButton: true,
        confirmButtonText: 'Guardar',
        cancelButtonText: 'Cancelar',
        inputValidator: value => (value ? null : 'Debe completar el campo.')
      }).then(({ value }) => {
        commit(LOADING, true, ROOT)

        const { id, passengers, rate, rooming, departure, seats } = state

        axios
          .post(
            API_ENDPOINT_BASE + '/booking/assign',
            stringify({
              id,
              ref: value,
              rate_id: rate.id,
              departure_id: departure.id,
              seats,
              rooming,
              passengers
            })
          )
          .then(response => {
            swal({
              title: 'Lugares bloqueados',
              html: response.data.msg,
              type: 'success',
              onClose: () => window.location.reload()
            })
          })
          .catch(error => {
            swal({ html: error.response.data.msg, type: 'error' })
          })
          .finally(() => {
            dispatch('RESET')
            commit(LOADING, false, ROOT)
          })
      })
    },
    SEATING ({ commit, state, dispatch }) {
      commit(LOADING, true, ROOT)

      const { id, seats, departure } = state

      return new Promise((resolve, reject) => {
        axios
          .post(
            API_ENDPOINT_BASE + '/booking/seating',
            stringify({ id, departure_id: departure.id, seats })
          )
          .then(({ data }) => {
            dispatch('TIMER')
            resolve(data)
          })
          .catch(error => {
            swal({ html: error.response.data.msg, type: 'error' })
            reject(error)
          })
          .finally(() => commit(LOADING, false, ROOT))
      })
    }
  }
}
